// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"8":"editor","140":"email_verified","419":"wiki","542":"overview","884":"admin"}[chunkId] + "." + {"8":"b93ed0eb","140":"bd81445c","419":"772f0aec","542":"ef36b4ad","884":"d9369c91"}[chunkId] + ".css";
};